export function localStorageSizes(): Record<string, number> {
  const sizes: Record<string, number> = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)!;
    const value = localStorage.getItem(key) ?? "";
    sizes[key] = new Blob([value]).size;
  }
  return sizes;
}
